import { useEffect, useState } from "react";
// import "react-input-range/lib/css/index.css";
import productDatas from "../../data/products.json";
import BreadcrumbCom from "../BreadcrumbCom";
import ProductCardStyleOne from "../Helpers/Cards/ProductCardStyleOne";
import DataIteration from "../Helpers/DataIteration";
import Layout from "../Partials/Layout";
import ProductsFilter from "./ProductsFilter";
import axios from "../../api/axios";
import Pagination from "../Helpers/Pagination";

export default function AllProductPage() {
  const [filters, setFilter] = useState({});
  const [priceRange, setPriceRange] = useState({ min: 0, max: 50000 });
  const [sortValue, setSortValue] = useState("default");
  const [productList, setProductList] = useState([]);
  const [totalProducts, setTotalProducts] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [filterToggle, setToggle] = useState(false);
  const [storage, setStorage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const itemsPerPage = 18;

  const breadcrumbPaths = [
    { name: "home", path: "/" },
    { name: "Shop All", path: "/all-products" },
  ];

  const checkboxHandler = (e) => {
    const { name } = e.target;
    setFilter((prevState) => ({
      ...prevState,
      [name]: !prevState[name],
    }));
  };

  const sortHandler = (e) => {
    setSortValue(e.target.value);
  };

  const filterStorage = (value) => {
    setStorage(value);
  };

  const changePageNumber = (number) => {
    setPageNumber(number);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const updateFilters = (filters) => {
    setFilter(filters);
  };

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const fetchFilteredProducts = async () => {
      setIsLoading(true);
      try {
        const response = await axios.post("/product/getFilteredProducts", {
          filters: filters,
          priceRange: priceRange,
          sort: sortValue,
          page: pageNumber,
          limit: itemsPerPage,
        });
        if (isMounted) {
          setProductList(response.data.products);
          setTotalProducts(response.data.total);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
        isMounted = false;
        controller.abort();
      }
    };

    fetchFilteredProducts();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [filters, priceRange, sortValue, pageNumber]);

  return (
    <>
      <Layout>
        <div className="products-page-wrapper w-full">
          <div className="container-x mx-auto">
            <BreadcrumbCom paths={breadcrumbPaths} />
            <div className="w-full lg:flex lg:space-x-[30px]">
              <div className="lg:w-[270px]">
                <ProductsFilter
                  updateFilters={updateFilters}
                  filterToggle={filterToggle}
                  filterToggleHandler={() => setToggle(!filterToggle)}
                  filters={filters}
                  checkboxHandler={checkboxHandler}
                  priceRange={priceRange}
                  priceRangeHandler={(value) => setPriceRange(value)}
                  storage={storage}
                  filterstorage={filterStorage}
                  className="mb-[30px]"
                />

                <div className="w-full hidden lg:block h-[295px]">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/ads-5.png`}
                    alt=""
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>

              <div className="flex-1">
                <div className="products-sorting w-full bg-white md:h-[70px] flex md:flex-row flex-col md:space-y-0 space-y-5 md:justify-between md:items-center p-[30px] mb-[40px]">
                  <div>
                    <p className="font-400 text-[13px]">
                      <span className="text-qgray"> Showing</span>{" "}
                      {(pageNumber - 1) * itemsPerPage + 1} {" - "}{" "}
                      {Math.min(pageNumber * itemsPerPage, totalProducts)}{" "}
                      {" of "}
                      {totalProducts} results
                    </p>
                  </div>
                  <div className="flex space-x-3 items-center">
                    <span className="font-400 text-[13px]">Sort by:</span>
                    <div className="flex space-x-3 items-center border-b border-b-qgray">
                      <select
                        className="font-400 text-[13px] text-qgray"
                        value={sortValue}
                        onChange={sortHandler}
                      >
                        <option value="default">Default</option>
                        <option value="price-low-high">
                          Price, Low to High
                        </option>
                        <option value="price-high-low">
                          Price, High to Low
                        </option>
                        <option value="new-arrival">Newest Arrivals</option>
                        <option value="a-z">Alphabetically, A-Z</option>
                        <option value="z-a">Alphabetically, Z-A</option>
                      </select>
                    </div>
                  </div>
                  <button
                    onClick={() => setToggle(!filterToggle)}
                    type="button"
                    className="lg:hidden flex items-center space-x-2 px-3 sm:px-4 py-2 rounded-md border border-theme text-theme hover:bg-theme hover:text-white transition-colors duration-200 text-sm"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
                      />
                    </svg>
                    <span className="text-sm font-medium">Filters</span>
                  </button>
                </div>
                {isLoading ? (
                  <div className="flex justify-center items-center h-64">
                    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-theme"></div>
                  </div>
                ) : (
                  <div className="grid xl:grid-cols-3 sm:grid-cols-2 grid-cols-1 xl:gap-[30px] gap-5 mb-[40px]">
                    <DataIteration
                      datas={productList}
                      startLength={0}
                      endLength={productList.length}
                    >
                      {({ datas }) => (
                        <div data-aos="fade-up" key={datas.id}>
                          <ProductCardStyleOne datas={datas} />
                        </div>
                      )}
                    </DataIteration>
                  </div>
                )}
                <div className="products-sorting w-full bg-white md:h-[70px] flex flex-col justify-center items-center p-[30px] mb-[40px]">
                  <Pagination
                    totalLength={totalProducts}
                    itemsPerPage={itemsPerPage}
                    currentPage={pageNumber}
                    changePageNumber={changePageNumber}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}
